<template>
  <div class="incremenetal-revenue-empty-state d-flex flex-column align-center">
    <div class="icon-container mt-6 mb-10">
      <mf-icon icon="attach_money" size="28" color="cinza-0" />
    </div>
    <h1 class="mb-2">Faturamento incremental sem resultados!</h1>
    <p class="mb-4">Não existe resultado em nenhuma campanha de oferta no período atual.</p>
    <mf-button label="Ir para Gestão de ofertas" icon="arrow_forward" icon-position="right" @click="$router.push('/campanhas/gestao-ofertas')" />
  </div>
</template>

<script>
export default {
  name: 'IncrementalRevenueEmptyState',
}
</script>

<style lang="scss" scoped>
.incremenetal-revenue-empty-state {
  background-color: $branco;
  border-radius: 8px;
  box-shadow: $shadow-card;
  height: 100%;
  min-height: 315px;
  overflow: hidden;
  .icon-container {
    height: 48px;
    width: 48px;
    background-color: $cinza-l90;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &::before {
      content: url('../../../../assets/incremental-revenue-empty-state-pulse.svg');
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 0;
    }
  }

  h1 {
    font-size: 16px;
    color: $cinza-d10;
    line-height: 19.2px;
    font-weight: 700;
    z-index: 1;
  }
  p {
    z-index: 1;
    max-width: 305px;
    text-align: center;
    font-size: 14px;
    color: $cinza-l10;
    line-height: 20px;
  }
}
</style>
